import VisualTabView from './VisualTabView';

export * from './VisualTabView';
export default VisualTabView;
